import Vue from 'vue'
import VueRouter from 'vue-router'
import Autocom from '../components/Autocom.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/autocom',
    name: 'Autocom',
    component: Autocom
  },
 {
    path: '/finautocom',
    name: 'FinAutocom',
    component: () => import(/* webpackChunkName: "FinAutocom" */ '../components/FinAutocom.vue')
  },
  {
      path: '/finclikauto',
      name: 'FinClikAuto',
      component: () => import(/* webpackChunkName: "FinClikAuto" */ '../components/FinClikAuto.vue')
  },
  {
      path: '/finseminuevos',
      name: 'FinSeminuevos',
      component: () => import(/* webpackChunkName: "FinSeminuevos" */ '../components/FinSeminuevos.vue')
  },
  {
      path: '/fingoriders',
      name: 'FinGoriders',
      component: () => import(/* webpackChunkName: "FinGoriders" */ '../components/FinGoriders.vue')
  },
  {
    path: '/goriders',
    name: 'GoRiders',
    component: () => import(/* webpackChunkName: "GoRiders" */ '../components/GoRiders.vue')
  },
  {
    path: '/clikauto',
    name: 'ClikAuto',
    component: () => import(/* webpackChunkName: "GoRiders" */ '../components/ClikAuto.vue')
  },
  {
    path: '/seminuevos',
    name: 'Seminuevos',
    component: () => import(/* webpackChunkName: "GoRiders" */ '../components/Seminuevos.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});




export default router
